import { format } from '@seek/currency';
import type { Locale } from '@seek/melways-sites';

export const formatSalaryValues = ({
  minimumSalaryValue,
  maximumSalaryValue,
  currency,
  locale,
}: {
  minimumSalaryValue: number;
  maximumSalaryValue: number | null;
  currency: string;
  locale: Locale;
}) => {
  const formattedMinimumSalary = format(minimumSalaryValue, {
    display: 'code',
    dropFraction: true,
    locale,
    currency,
  });
  if (maximumSalaryValue) {
    return `${formattedMinimumSalary} - ${format(maximumSalaryValue, {
      dropFraction: true,
      locale,
      currency,
      display: 'noSymbol',
    })}`;
  }

  return formattedMinimumSalary;
};
